import React, {createContext, useContext, useMemo} from 'react';

type PanelBankWidthProviderProps = {
  panelBankWidth: number;
  setPanelBankWidth: (width: number) => void;
  children: React.ReactNode;
};

type PanelBankWidthContextType = {
  panelBankWidth: number;
  setPanelBankWidth: (width: number) => void;
};

const PanelBankWidthContext = createContext<
  PanelBankWidthContextType | undefined
>(undefined);

export const PanelBankWidthContextProvider = ({
  panelBankWidth,
  setPanelBankWidth,
  children,
}: PanelBankWidthProviderProps) => {
  const value = useMemo(
    () => ({
      panelBankWidth,
      setPanelBankWidth,
    }),
    [panelBankWidth, setPanelBankWidth]
  );

  return (
    <PanelBankWidthContext.Provider value={value}>
      {children}
    </PanelBankWidthContext.Provider>
  );
};

export const usePanelBankWidthContext = () => {
  const value = useContext(PanelBankWidthContext);

  if (value == null) {
    throw new Error(
      'usePanelBankWidthContext must be used within a PanelBankWidthContext'
    );
  }

  return value;
};
